module.exports = __webpack_public_path__ + "static/img/569643561356asmasjas.f29eae73.jpg";